import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { AiringDateProps } from 'components/widgets/CardView/types';

import { capitalizeNow } from './utils';

import styles from './AirTime.module.scss';

export type Props = {
  airingDate: AiringDateProps | undefined;
  isInfo?: boolean;
  className?: string;
  showNowLabel?:boolean;
};

function AirTimeV2({ showNowLabel, airingDate, className, isInfo = false }: Props) {
  if (!airingDate || !airingDate.airingTime && !airingDate.airingLabel) {
    return null;
  }

  const label = capitalizeNow(airingDate.airingLabel);

  return (
    <div className={cn(styles.airTime, className)}>
      {label && (
        <>
          <FormattedMessage defaultMessage={`${label}`} id={`Rail.RailCard.AirTime.${label}`} tagName='span' />{' '}
          <span>{airingDate.airingTime}</span>
        </>
      )}
      {!label && airingDate.isFutureDate && !isInfo && (
        <>
          <span>{airingDate.onlyLongWeekdayFormattedDate}</span>
          <span>{airingDate.withoutWeekdayFormattedDate}</span>
        </>
      )}
      {!label && (airingDate.isPastDate || isInfo) && (
        <>
          {
            showNowLabel
              ? <FormattedMessage  defaultMessage='Now' id='Rail.RailCard.AirTime.Now' tagName='span' />
              : <span>{airingDate.withLongWeekdayFormattedDate}</span>
          }
          <span>{airingDate.airingTime}</span>
        </>
      )}
    </div>
  );
}

export default AirTimeV2;
